import {BaseSS} from './BaseSS';

const STORAGE_KEY = 'playbackCurrentTime';

export class PlaybackCurrentTime extends BaseSS<number> {
  constructor() {
    super(STORAGE_KEY);
  }
}
